/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  FetchCommunityFinancialsResponseFinancialSummary,
  FetchCommunityFinancialsResponseFinancialSummaryFromJSON,
  FetchCommunityFinancialsResponseFinancialSummaryToJSON,
} from './'

/**
 * Response containing the financial obligations of community directors, tutors, and families.
 * @export
 * @interface FetchCommunityFinancialsResponse
 */
export interface FetchCommunityFinancialsResponse {
  /**
   * List of community financial summaries.
   * @type {Array<FetchCommunityFinancialsResponseFinancialSummary>}
   * @memberof FetchCommunityFinancialsResponse
   */
  financialSummary: Array<FetchCommunityFinancialsResponseFinancialSummary>
}

export function FetchCommunityFinancialsResponseFromJSON(
  json: any
): FetchCommunityFinancialsResponse {
  return FetchCommunityFinancialsResponseFromJSONTyped(json, false)
}

export function FetchCommunityFinancialsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchCommunityFinancialsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    financialSummary: (json['financialSummary'] as Array<any>).map(
      FetchCommunityFinancialsResponseFinancialSummaryFromJSON
    ),
  }
}

export function FetchCommunityFinancialsResponseToJSON(
  value?: FetchCommunityFinancialsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    financialSummary: (value.financialSummary as Array<any>).map(
      FetchCommunityFinancialsResponseFinancialSummaryToJSON
    ),
  }
}
